import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

import type { getPosts } from "../utils";
import PostCardMini from "./post-card-mini";

export function Posts({
  data,
}: {
  data: Awaited<ReturnType<typeof getPosts>>;
}) {
  const [posts, setPosts] = useState(data.posts);
  const [rawTake, setRawTake] = useState(data.take);
  const take = Math.min(Number(rawTake) || 9, data.postsCount);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("take", searchParams.get("take") || String(take));
    if (posts.length < take) {
      fetch(
        window.location.origin + "/blog/posts.json?" + searchParams.toString(),
      )
        .then((r) => r.json())
        .then((v) => setPosts(v.posts));
    }
  }, [take, posts.length]);

  return (
    <>
      <p className="text-primary mb-5 text-lg font-semibold">
        Showing 1-{posts.length} of {data.postsCount} posts
      </p>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <PostCardMini key={post.id} {...post.data} slug={post.slug} />
        ))}
      </div>
      <div className="mt-10 flex w-full justify-center">
        {posts.length < data.postsCount && (
          <Button
            size="lg"
            onClick={() => {
              const newTake = take + 9;
              if (window.location.pathname.endsWith("search")) {
                const searchParams = new URLSearchParams(
                  window.location.search,
                );
                searchParams.set("take", String(newTake));
                history.pushState(
                  {},
                  "",
                  location.pathname + "?" + searchParams.toString(),
                );
              }
              setRawTake(newTake);
            }}
          >
            Load More
          </Button>
        )}
      </div>
    </>
  );
}
